import { Injectable } from "@angular/core";
import { BaseAuthHttpService } from "@apps/patient-core/src/app/services/abstracts/auth-http.service";

@Injectable({
  providedIn: "root",
})
export class PatientAuthHttpService extends BaseAuthHttpService {}
